// extracted by mini-css-extract-plugin
export default {"emptyContent":"EmptyContent_emptyContent__uo2vf","emptyIcon":"EmptyContent_emptyIcon__wJk0a"};